// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__163ja","active":"downloadDropdown_active__1O4nk"};